(function(){
  function initRow(root){
    var row=root.querySelector('.jmh-row');if(!row)return;
    var l=root.querySelector('.jmh-arrow--l'),r=root.querySelector('.jmh-arrow--r');
    function vis(){return Array.prototype.filter.call(row.children,function(c){return !c.hidden});}
    function place(){var c=vis()[0];if(!c)return;var m=c.querySelector('.jmh-card__media');if(!m)return;var t=m.offsetHeight/2;if(l)l.style.top=t+'px';if(r)r.style.top=t+'px';}
    function upd(){var max=row.scrollWidth-row.clientWidth-2;if(l)l.disabled=row.scrollLeft<=2;if(r)r.disabled=row.scrollLeft>=max;}
    function step(dir){var c=vis()[0];var w=c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(row).columnGap||12):row.clientWidth;row.scrollBy({left:dir*w,behavior:'smooth'});}
    if(l)l.addEventListener('click',function(){step(-1)});
    if(r)r.addEventListener('click',function(){step(1)});
    row.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',function(){place();upd();});
    root._jmhUpdate=function(){row.scrollLeft=0;place();upd();};
    Array.prototype.forEach.call(row.querySelectorAll('img'),function(i){if(!i.complete)i.addEventListener('load',function(){place();upd();},{once:true});});
    place();upd();
  }
  function initTabs(root){
    var tabs=root.querySelectorAll('.jmh-tab');if(!tabs.length)return;
    var items=root.querySelectorAll('[data-jmh-tabs]');
    var all=root.getAttribute('data-first-all')==='true';
    function show(i){
      Array.prototype.forEach.call(tabs,function(t,j){t.setAttribute('aria-selected',j===i?'true':'false');t.tabIndex=j===i?0:-1;});
      Array.prototype.forEach.call(items,function(it){var k=' '+it.getAttribute('data-jmh-tabs')+' ';it.hidden=!((all&&i===0)||k.indexOf(' t'+(i+1)+' ')>-1);});
      if(root._jmhUpdate)root._jmhUpdate();
    }
    Array.prototype.forEach.call(tabs,function(t,i){t.addEventListener('click',function(){show(i)});});
    show(0);
  }
  function initAnn(root){
    var msgs=root.querySelectorAll('.jmh-ann__msg');if(msgs.length<2)return;var i=0,timer;
    function go(n){msgs[i].classList.remove('is-on');i=(n+msgs.length)%msgs.length;msgs[i].classList.add('is-on');}
    function auto(){clearInterval(timer);timer=setInterval(function(){go(i+1)},5000);}
    var p=root.querySelector('.jmh-ann__arrow--p'),n=root.querySelector('.jmh-ann__arrow--n');
    if(p)p.addEventListener('click',function(){go(i-1);auto();});
    if(n)n.addEventListener('click',function(){go(i+1);auto();});
    auto();
  }
  function initFooter(root){
    var mq=window.matchMedia('(max-width: 749px)');
    function set(){Array.prototype.forEach.call(root.querySelectorAll('.jmh-fcol'),function(d){if(mq.matches)d.removeAttribute('open');else d.setAttribute('open','');});}
    root.querySelectorAll('.jmh-fcol summary').forEach(function(s){s.addEventListener('click',function(e){if(!mq.matches)e.preventDefault();});});
    set();if(mq.addEventListener)mq.addEventListener('change',set);
  }
  function initPage(){
    var de=document.documentElement;
    if(!document.querySelector('.jmh-hero'))return;
    de.classList.add('jmh-page');
    var ticking=false;
    function upd(){ticking=false;var y=window.pageYOffset||de.scrollTop||0;var solid=y>2;
      if(solid!==de.classList.contains('jmh-solid'))de.classList.toggle('jmh-solid',solid);
      if(de.scrollLeft)de.scrollLeft=0;if(document.body.scrollLeft)document.body.scrollLeft=0;}
    function on(){if(!ticking){ticking=true;requestAnimationFrame(upd);}}
    window.addEventListener('scroll',on,{passive:true});
    window.addEventListener('touchmove',on,{passive:true});
    window.addEventListener('resize',on);
    if(window.visualViewport)window.visualViewport.addEventListener('scroll',on);
    upd();
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-jmh-row]').forEach(initRow);
    (scope||document).querySelectorAll('[data-jmh-tabbed]').forEach(initTabs);
    (scope||document).querySelectorAll('[data-jmh-ann]').forEach(initAnn);
    (scope||document).querySelectorAll('[data-jmh-footer]').forEach(initFooter);
    if(!scope)initPage();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

/* jm card bg match: set each card media background to the photo's own edge color so packshots never show a band */
(function(){
  function px(d,i){return [d[i],d[i+1],d[i+2]]}
  function near(a,b){return Math.abs(a[0]-b[0])<6&&Math.abs(a[1]-b[1])<6&&Math.abs(a[2]-b[2])<6}
  function fit(img){
    var m=img.closest('.jmh-card__media');if(!m||m.getAttribute('data-jmbg'))return;
    try{
      var c=document.createElement('canvas');c.width=16;c.height=16;var x=c.getContext('2d');
      x.drawImage(img,0,0,16,16);var d=x.getImageData(0,0,16,16).data;
      var tl=px(d,0),tr=px(d,15*4),bl=px(d,15*16*4),br=px(d,(15*16+15)*4);
      m.setAttribute('data-jmbg','1');
      if(near(tl,tr)&&near(tl,bl)&&near(tl,br)){
        var r=Math.round((tl[0]+tr[0]+bl[0]+br[0])/4),g=Math.round((tl[1]+tr[1]+bl[1]+br[1])/4),b=Math.round((tl[2]+tr[2]+bl[2]+br[2])/4);
        m.style.background='rgb('+r+','+g+','+b+')';
        if(r>=250&&g>=250&&b>=250)m.classList.add('jmh-card__media--white');
      }else if(getComputedStyle(img).objectFit==='contain'){img.style.objectFit='cover';}
    }catch(e){}
  }
  function scan(scope){
    (scope||document).querySelectorAll('.jmh-card__media img').forEach(function(img){
      if(img.complete&&img.naturalWidth)fit(img);else img.addEventListener('load',function(){fit(img)},{once:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan()});else scan();
  document.addEventListener('shopify:section:load',function(e){scan(e.target)});
})();
